import { useEffect, useState } from "react";

// STYLES
import * as Style from "./SelectUsersStyle";

// LIBRARIES

// MISC
import { COLORS } from "constants/styleVariables";
import {
  ButtonTypes
} from "models/GeneralTypes/generalTypes";
import { ISelectUsersApiParams } from "models/interfaces";
import { IProps } from "./SelectUsersModel";

// ASSETS
import PersonDefaultIcon from "assets/Icons/defaultPersonPhoto.jpg";

// REDUX
import { getAllSelectUsers } from "api/userApi";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { setUsersListState, usersList } from "slices/promoCodesSlice";
import { toggleModalState } from "slices/uiSlice";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import { InputAtomTypes } from "components/Atoms/InputAtom/InputAtomModel";

const SelectUsers = (props: IProps) => {
  // PROPS
  const { handleClose = () => { } } = props;

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const promoCodeUsers = useAppSelector(usersList);

  // CONSTANTS USING HOOKS
  const [value, setValue] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(0)
  const [usersData, setUsersData] = useState<any[]>()
  const [usersListData, setUsersListData] = useState(promoCodeUsers)

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    let payload: ISelectUsersApiParams = {
      page: "0",
    }
    dispatch(getAllSelectUsers(payload))
      .unwrap()
      .then((response) => {
        setUsersData(response.content)
        setCurrentPage(currentPage + 1);
      });
    // eslint-disable-next-line
  }, []);

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleCloseModal = () => {
    dispatch(
      toggleModalState({
        isVisible: false,
        type: "",
      })
    );
  }

  const handleScrollEnd = (e: React.UIEvent<HTMLDivElement>) => {
    const divElement = e.target as HTMLDivElement;
    const { scrollTop, scrollHeight, clientHeight } = divElement;
    if (scrollTop + clientHeight === scrollHeight) {
      getUsersData(currentPage);
    }
  };

  const getUsersData = (pageNumber) => {
    let payload: ISelectUsersApiParams = {
      page: pageNumber,
    }
    dispatch(getAllSelectUsers(payload))
      .unwrap()
      .then((response) => {
        setUsersData([...usersData, ...response.content])
        setCurrentPage(pageNumber + 1);
      });
  };

  const handleSelectUser = (id) => {
    if (usersListData.includes(id)) {
      setUsersListData(prevUsers => prevUsers.filter(userId => userId !== id))
    } else {
      setUsersListData(prevUsers => [...prevUsers, id])
    }
  }

  const handleSaveUsersListData = () => {
    dispatch(setUsersListState(usersListData))
  }

  const handleSaveAndClose = () => {
    handleSaveUsersListData()
    handleCloseModal()
  }

  return (
    <Style.DoorDetailsContainer>
      <Style.CloseIconContainer>
        <Style.CloseIcon onClick={handleClose} />
      </Style.CloseIconContainer>
      <Style.Title color={COLORS.terraCotta}>
        Users list
      </Style.Title>
      <Style.SearchWrapper>
        <Style.InputAtomContainer>
          <InputAtom
            placeholder={"Cauta..."}
            label={"Cauta user"}
            inputValue={value}
            setInputValue={(value) =>
              setValue(value)
            }
            type={InputAtomTypes.SEARCH}
          />
        </Style.InputAtomContainer>
      </Style.SearchWrapper>
      <Style.UsersList onScroll={handleScrollEnd}>
        {usersData &&
          usersData.map((user, index) => {
            return (
              <Style.UserContainer onClick={() => handleSelectUser(user)}>
                <Style.CheckBox isSelected={usersListData.includes(user)} />
                <Style.UserIcon src={PersonDefaultIcon} />
                <Style.UserName>
                  {user?.fullName || "NO_NAME_PROVIDED"}
                </Style.UserName>
              </Style.UserContainer>
            )
          })
        }
      </Style.UsersList>
      <Style.ButtonContainer>
        <ButtonAtom
          text={"Salveaza"}
          type={ButtonTypes.MAIN_BUTTON}
          onClick={() => handleSaveAndClose()}
          width="169px"
        />
      </Style.ButtonContainer>



    </Style.DoorDetailsContainer>
  );
};

export default SelectUsers;
